import axios from 'axios';

const axiosServices = axios.create();

axiosServices.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['Accept'] = 'application/json';
    const workspaceId = localStorage.getItem('activeWorkspaceId');
    if (workspaceId) {
      config.headers['X-Workspace-ID'] = workspaceId;
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  },
);

axiosServices.interceptors.response.use(
  async (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = import.meta.env.VITE_FRONTEND_URL + '/signin';
    }
    return Promise.reject(
      (error.response && { ...error?.response?.data, status: error.response.status }) ||
        'Wrong Services',
    );
  },
);

export default axiosServices;
